module.exports = __webpack_public_path__ + "img/background-1.ff63c6ef.jpg";